import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import CONSTANTS from '../../_constants/constants';
import { environment } from '../../../environments/environment';
import { DefaultParams } from '../../_shared/interfaces/defaultParams';

import { UtilService } from '../../_shared/services/util.service';

import { OccupancyType } from './occupancy-type.model';

interface ExtendedDefaultParams extends DefaultParams {
  by_name?: any;
  by_occupancy?: any;
}

@Injectable({
  providedIn: 'root',
})
export class OccupancyTypeService {
  constructor(private http: HttpClient, private utilService: UtilService) {}

  private apiUrl = environment.apiEndpoint + 'occupancy_types';

  getFilterCriteria() {
    let defaultParams: ExtendedDefaultParams = {
      page: 1,
      sortDir: 'asc',
      sortedBy: 'name',
    };

    return defaultParams;
  }

  getOccupancyTypes(params = null): Observable<any> {
    if (!params) {
      params = this.getFilterCriteria();
    }

    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get(this.apiUrl, { params: queryParams }).pipe(
      map((resp) => {
        if (resp['data']) {
          return {
            data: resp['data'],
            meta: this.utilService.getItemsMetaData(resp, this.getFilterCriteria()),
          };
        } else {
          return resp;
        }
      })
    );
  }

  getOccupancyType(id: string, params = null): Observable<OccupancyType> {
    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get<OccupancyType>(`${this.apiUrl}/${id}`, {
      params: queryParams,
    });
  }

  // Save / Update
  saveOccupancyType(
    occupancyTypeId: string,
    occupancyType: OccupancyType,
    lang = ''
  ): Observable<OccupancyType> {
    const body = {
      occupancy_type: occupancyType,
      lang: lang || CONSTANTS.DEFAULT_CONTENT_LANGUAGE,
    };

    if (!occupancyTypeId) {
      return this.http.post<OccupancyType>(`${this.apiUrl}`, body);
    } else {
      return this.http.put<OccupancyType>(`${this.apiUrl}/${occupancyTypeId}`, body);
    }
  }
}
